import { api } from "#/lib/api-client";

export type FeatureHintResult = {
  viewCount: number;
  shouldShow: boolean;
};

/**
 * Records one more view of a named UI hint for the current user and reports
 * whether it's still within its "show for the first N visits" window.
 * POST /api/hr/feature-hints/{featureKey}/view?maxViews=N
 */
export async function recordFeatureHintView(featureKey: string, maxViews = 5): Promise<FeatureHintResult> {
  const { data } = await api.post<FeatureHintResult>(
    `/api/hr/feature-hints/${encodeURIComponent(featureKey)}/view`,
    null,
    { params: { maxViews } },
  );
  return data;
}
